import React from 'react'
import Button from '@components/V3/Button'
import Modal from '@components/V3/Modal'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

import useContactInfo from './Store/useContactInfo.main'

export default function ContactModal({isOpen, onClose}) {
  const {order} = useOrder()
  const supportOptions = useContactInfo(order.store?._id)
  const {t} = useTranslation('tracking', {keyPrefix: 'store.help'})

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={t('header')} forceJustoFont>
      <div className="flex flex-col gap-4">
        <div className="">
          <p className="text-sm font-semibold">{t('title')}</p>
          <p className="text-sm">{t('caption')}</p>
        </div>
        {supportOptions.whatsAppNumber ? (
          <Button
            full
            onClick={() => window.open(`https://wa.me/${supportOptions.whatsAppNumber}`)}>
            {t('options.whatsapp')}
          </Button>
        ) : null}
        {supportOptions.phone ? (
          <Button full onClick={() => window.open(`tel:${supportOptions.phone}`)}>
            {t('options.call', {phone: supportOptions.phone})}
          </Button>
        ) : null}
        {supportOptions.email ? (
          <Button full onClick={() => window.open(`mailto:${supportOptions.email}`)}>
            {t('options.email', {email: supportOptions.email})}
          </Button>
        ) : null}
      </div>
    </Modal>
  )
}
